(function () {
  'use strict';

  function nationalPart(raw, dial) {
    var v = String(raw || '').trim().replace(/[^\d+]/g, '');
    var cc = String(dial || '').replace('+', '');

    if (v.charAt(0) === '+') {
      v = v.slice(1);
      if (cc && v.indexOf(cc) === 0) {
        v = v.slice(cc.length);
      }
    } else if (cc && v.indexOf('00' + cc) === 0) {
      v = v.slice(2 + cc.length);
    }

    return v.replace(/^0+/, '');
  }

  function setupWrapper(wrap) {
    if (wrap.getAttribute('data-phone-ready') === 'true') return;
    wrap.setAttribute('data-phone-ready', 'true');

    var select = wrap.querySelector('[data-phone-code]');
    var input = wrap.querySelector('[data-phone-number]');
    if (!select || !input) return;

    var message = wrap.getAttribute('data-phone-error') || 'Bitte gib eine gueltige Telefonnummer ein.';

    function validate() {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;

      if (!input.value.trim()) {
        input.setCustomValidity('');
        return;
      }

      var min = parseInt(opt.getAttribute('data-min'), 10) || 4;
      var max = parseInt(opt.getAttribute('data-max'), 10) || 15;
      var nat = nationalPart(input.value, opt.value);

      if (nat.length < min || nat.length > max) {
        input.setCustomValidity(message);
      } else {
        input.setCustomValidity('');
      }
    }

    input.addEventListener('input', validate);
    input.addEventListener('blur', validate);
    select.addEventListener('change', validate);

    var form = input.form;
    if (form && form.getAttribute('data-phone-submit-bound') !== 'true') {
      form.setAttribute('data-phone-submit-bound', 'true');

      form.addEventListener('submit', function () {
        var fields = form.querySelectorAll('[data-phone-number]');

        for (var i = 0; i < fields.length; i++) {
          var field = fields[i];
          var scope = field.closest ? field.closest('[data-phone-wrapper]') : null;
          var code = scope ? scope.querySelector('[data-phone-code]') : null;
          if (!code) continue;

          var chosen = code.options[code.selectedIndex];
          if (!chosen) continue;

          var nat = nationalPart(field.value, chosen.value);
          if (nat) field.value = chosen.value + ' ' + nat;
        }
      });
    }

    validate();
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var wraps = root.querySelectorAll('[data-phone-wrapper]');
    for (var i = 0; i < wraps.length; i++) setupWrapper(wraps[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
